module.exports = __webpack_public_path__ + "static/roc-0d2e04e85ce51acee5bf5222f5536697.jpeg";